// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"7fb92f22","213":"39cffbeb","447":"a4394f00","472":"2531a66e","583":"2113f03a","584":"ee190e23","591":"dc392800","725":"7c6103e2","923":"70fdb1f9"}[chunkId] + ".chunk.js";
};